const initState = {
	page: 1,
	totalPages: 0,
	pageSize: 20,
	filters: {},
	selectedInputs: [],
};

export const advanceFilterPOReducer = (state = initState, action) => {
	switch (action.type) {
		case 'SET_PO_ADVANCE_FILTER':
			return {
				...state,
				filters: action?.payload?.filters || {},
				selectedInputs: action?.payload?.selectedInputs || [],
			};
		case 'CLEAR_PO_ADVANCE_FILTER':
			return {
				page: 1,
				totalPages: 0,
				pageSize: 20,
				filters: {},
				selectedInputs: [],
			};
		default:
			return state;
	}
};
